<template>
  <div class="relative">
    <div class="select cursor-pointer" v-html="keyValue ? keyValue : field.label" @click="toggleDropdown(!showDropdown)"/>
    <div v-if="showDropdown" :class="`dropdown absolute uppercase w-full bg-white border-black border-2 z-20`">
      <div v-for="(opt, o) in field.options" :key="o">
        <div v-if="field.options.length > 1 && opt.title" :class="`cursor-pointer p-2 border-b-2 border-black font-black hover:border-purple hover:bg-purple hover:text-white ${o > 0 ? 'border-t-2' : ''}`" v-text="opt.title" @click="onUpdate(opt, true)" />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CountriesSelect',
  props: [
    'field',
    'model',
    'handleUpdate'
  ],
  data() {
    return {
      showDropdown: false,
    }
  },
  computed: {
    keyValue() {
      let value = null
      this.field.options.map(o => {
        if(this.model[this.field.name] == o.title) {
          value = o.title
        }
      })
      return value
    }
  },
  methods: {
    toggleDropdown(show) {
      this.showDropdown = show
    },
    onUpdate(option, close = false) {
      this.handleUpdate(this.field.name, option.title)
      if(close) {
        this.toggleDropdown(false)
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.dropdown {
  margin-top: -2px;
  max-height: 320px;
  overflow-y: scroll;
}
.select {
  padding-right: 20px;
}
</style>